export const RefundDutiesMode = {
  OFF: "off",
  ALL: "all",
  COVERED_ONLY: "covered_only",
} as const;
export type RefundDutiesMode =
  (typeof RefundDutiesMode)[keyof typeof RefundDutiesMode];

export function resolveRefundDutiesMode(
  returns: { refundDutiesMode?: RefundDutiesMode | null } | null | undefined,
): RefundDutiesMode {
  return returns?.refundDutiesMode ?? RefundDutiesMode.OFF;
}
